import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { showModalAction } from '@/shared/store/modals/actions';
import { ModalName } from '@/shared/store/modals/constants';
import { toast } from '@/shared/hooks/useToast';

export const useHandleBorrowClick = (
    leverage: any,
    address: string,
    refreshAgreements: () => void,
) => {
    const dispatch = useDispatch();

    return useCallback(() => {
        if (!leverage) {
            toast({
                title: 'There was an error fetching leverage data',
                variant: 'error',
            });
            return;
        }

        dispatch(
            showModalAction({
                modalName: ModalName.BORROW_MODAL,
                modalTitle: `Borrow ${leverage.symbol}`,
                modalProps: {
                    tokenSymbol: leverage.symbol,
                    agreementAddress: address,
                    tokenAddress: leverage.address,
                    refresh: refreshAgreements,
                },
            }),
        );
    }, [dispatch, leverage, address, refreshAgreements]);
};
